

























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import AppSwitch from '@/views/kyc-form/component/AppSwitch.vue'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import Switching from '@master/model/kyc-form/Switching'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch,
    AppRadioSelection,
    AppForm
  }
})
export default class ReplacementOrSwitching extends Vue {
  selectedClient = 'Client 1';

  @kycFormStore.State
  kycForm!: KYCForm;

  @kycFormStore.State
  private computedValidationResult: any

  @inject()
  private projectInfo: IProjectInfo;

  get sectionErrors () {
    return this.computedValidationResult['Replacement / Switching'] || {}
  }

  get replacementSectionErrors () {
    const errors = this.sectionErrors[this.selectedClient] || []
    const commonErrors = this.sectionErrors.Common || []
    errors.push(...commonErrors)
    const finalErrors: { key: string; msg: string }[] = []
    errors.map(({ key, message }) => {
      key.map(variableName => {
        finalErrors.push({
          key: variableName,
          msg: message
        })
      })
    })
    return [...new Set(finalErrors)]
  }

  get sharedSwitchingAttributes () {
    return this.kycForm.client1.switching
  }

  get switchingClient () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.switching
    } else {
      return this.kycForm.client2.switching
    }
  }

  get adviserDeclaration () {
    return this.kycForm.adviser.declaration
  }

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert(
        'Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.'
      )
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  get switchingStructure (): FormStructure<Switching> {
    return [
      {
        label: 'Details of Original Product',
        key: 'detail'
      }, {
        label: 'Name of Financial Institution',
        key: 'name'
      }, {
        label: 'Type of investment<br />e.g. life or accident & health plan',
        key: 'planType'
      }, {
        label: 'Policy/Product Number',
        key: 'policyNum'
      }, {
        label: 'Inception Date',
        key: 'inceptionDate'
      }, {
        label: 'Surrender Date',
        key: 'surrenderDate'
      }, {
        label: 'Benefits Provided',
        key: 'benefitsProvided'
      }, {
        label: 'Reasons for Replacement',
        key: 'reasons',
        model: {
          get: () => this.sharedSwitchingAttributes.reasons,
          set: (value) => { this.sharedSwitchingAttributes.reasons = value as string }
        },
        classes: ['colspan']
      }
    ]
  }

  @Watch('adviserDeclaration.acknowledgement')
  adviserAckOnChange () {
    if (!this.adviserDeclaration.acknowledgement) {
      this.adviserDeclaration.acknowledgementNotes = ''
    }
  }
}
